// extracted by mini-css-extract-plugin
export var card = "_7k-0";
export var expandedCard = "_7k-2";
export var paginated = "_7k-1";